
import Vue from "vue";
import { ApiService } from "@/services/ApiService";
import { error } from "@/services/LoggerService";
import { formatDate } from "@/mixins/shared";

export default Vue.extend({
  name: "BarrelBreakdown",
  props: {
    barrelId: String,
    showRemoval: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      defaultBadgeClass: "badge badge-light-success mr-3",
      BarrelCapacity: "",
      BarrelStatus: "",
      BarrelFullness: "",
      BarrelActive: true,
      Date: "",
      barrel: {} as any,
      loading: false,
      customerName: "",
      customerPhoneNumber: "",
    };
  },
  watch: {
    async barrelId(newVal, oldVal) {
      await this.getDetails(newVal);
    },
  },
  computed: {
    pybNumber() {
      return this.barrelId?.split("_")[0];
    },
    date(): string {
      return formatDate(this.Date);
    },
    fullnessNumber(): string {
      if (!this.barrel.BarrelFullness) return "0";
      return this.barrel.BarrelFullness.replace("%", "");
    },
  },
  methods: {
    statusBadgeClass(barrelStatus: string): string {
      const defaultClass = "badge mr-3";
      return barrelStatus === "Barrel Held"
        ? `badge-light-warning ${defaultClass}`
        : `badge-light-success ${defaultClass}`;
    },
    yesNo(value: boolean) {
      return value ? "Yes" : "No";
    },
    async getDetails(barrelId: string) {
      try {
        if (!barrelId) return;
        this.loading = true;
        this.$emit("startBarrelLoading");
        let result = await ApiService.Instance.barrelDetails({
          logicalBarrelId: barrelId!,
        });
        this.customerName = result.customerName;
        this.customerPhoneNumber = result.customerPhoneNumber;
        this.barrel = result.barrel;
        this.Date = result.barrel.Date;
        this.$emit("fullnessRetrieved", result.barrel.BarrelFullness);
        this.loading = false;
        this.$emit("stopBarrelLoading");
      } catch (e) {
        this.$emit("stopBarrelLoading");
        this.loading = false;
        error(e);
      }
    },
  },
  async beforeMount() {
    await this.getDetails(this.barrelId!);
  },
});
